import { Evento } from '@/types/eventos/eventos/evento';
import { Service } from '../mainService';
import { FiltrosEventos } from '@/types/eventos/eventos/filtros-eventos';
import { PortalError } from '@/types/portal-error';

const eventosService = {
    filtrarEventos,
    buscarEvento,
    adicionarEvento,
    editarEvento,
    removerEvento,
    listarTiposEvento,
    listarTiposArquivoEvento,
    baixarAnexo,
    buscarHistorico
}

async function filtrarEventos(
    page: number,
    pageSize: number,
    filtros: FiltrosEventos
  ): Promise<any> {
    try {
      const url = `${
        process.env.VUE_APP_LICITACOES_API
      }/eventos/filtrarEventos?page=${page}&pageSize=${pageSize}${filtros.toQueryString()}`;
      const response = await Service.$http.get(url);
      if (response && response.status === 200) {
        return response.data;
      } else {
        console.error("Falha ao filtrarProgramacoes", response);
        throw new PortalError(
          response.data?.msg ||
            "Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!"
        );
      }
    } catch (e: any) {
      console.error("Falha ao filtrar programações", e);
      throw new PortalError(e.response.data.msg ?? e);
    }
  }

async function buscarEvento(id: string): Promise<Evento> {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_LICITACOES_API + "/eventos/buscar/"+id);
        const evento = Object.assign(new Evento(), response.data);
        return evento;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarEvento(infoEvento: Evento, arquivos: any[]) {
    try {
        const tiposArquivo = await listarTiposArquivoEvento()
        const data = new FormData();
        data.append('DeTitulo', infoEvento.DeTitulo)
        data.append('DeDescricao', infoEvento.DeDescricao)
        data.append('IdTipoEvento', infoEvento.IdTipoEvento?.toString() || '')
        data.append('DtInicio', infoEvento.DtInicio?.toISOString() || '')
        data.append('DtFim', infoEvento.DtFim?.toISOString() || '')
        data.append('VlGastoTotal', infoEvento.VlGastoTotal.toString())
        if(infoEvento.IdProgramacao !== null || infoEvento.IdProgramacao !== undefined) {
            data.append('IdProgramacao', infoEvento.IdProgramacao?.toString() || '')
        }
        for (let index = 0; index < tiposArquivo.data.length; index++) {
            const tipoArquivo = tiposArquivo.data[index];
            data.append(`Arq${tipoArquivo.IdTipoArquivo}`, arquivos[tipoArquivo.IdTipoArquivo])
        }
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/eventos/adicionar", data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        if ([400,403].includes(e.response.status)) throw new PortalError(e.response.data.erros ?? e.response.data.msg);
        else throw new PortalError("Erro inesperado");
    }
}

async function editarEvento(infoEvento: Evento, arquivos: any[]) {
    try {
        const tiposArquivo = await listarTiposArquivoEvento()
        const data = new FormData();
        data.append('DeTitulo', infoEvento.DeTitulo)
        data.append('DeDescricao', infoEvento.DeDescricao)
        data.append('IdTipoEvento', infoEvento.IdTipoEvento?.toString() || '')
        data.append('DtInicio', infoEvento.DtInicio?.toISOString() || '')
        data.append('DtFim', infoEvento.DtFim?.toISOString() || '')
        data.append('VlGastoTotal', infoEvento.VlGastoTotal.toString())
        if(infoEvento.IdProgramacao !== null || infoEvento.IdProgramacao !== undefined) {
            data.append('IdProgramacao', infoEvento.IdProgramacao?.toString() || '')
        }
        for (let index = 0; index < tiposArquivo.data.length; index++) {
            const tipoArquivo = tiposArquivo.data[index];
            data.append(`Arq${tipoArquivo.IdTipoArquivo}`, arquivos[tipoArquivo.IdTipoArquivo])
        }
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/eventos/editar/" + infoEvento.IdEvento, data);
        return response;
    } catch (e: any) {
        if ([400,403].includes(e.response.status)) throw new PortalError(e.response.data.erros ?? e.response.data.msg);
        else throw new PortalError("Erro inesperado");
    }
}

async function removerEvento(id: number) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_LICITACOES_API + "/eventos/remover/"+id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarTiposEvento() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/eventos/tiposEvento"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarTiposArquivoEvento() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/eventos/tiposArquivoEvento"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function baixarAnexo(id) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_LICITACOES_API + "/eventos/baixaranexo/" + id, { responseType: "blob" });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarHistorico(
    idEvento: number,
    page: number,
    size: number
  ): Promise<any> {
    try {
      const url = `${process.env.VUE_APP_LICITACOES_API}/eventos/buscarLogs/${idEvento}?page=${page}&pageSize=${size}`;
      const response = await Service.$http.get(url);
      if (response && response.status === 200) return response.data;
      else {
        console.error("Falha ao buscar histórico do contrato", response);
        return null;
      }
    } catch (e: any) {
      return e.response;
    }
  }

export default eventosService;